export function saveExamAnswers(examId,answers)
{
    if(answers==null)
        localStorage.removeItem('exam_ans'+examId);
    else
        localStorage.setItem('exam_ans'+examId,JSON.stringify(answers));
};

export function loadExamAnswers(examId){
    var ans = null ;
    try
    {
        var loadedAnses = localStorage.getItem('exam_ans'+examId);
        if(loadedAnses!=null)
            ans = JSON.parse(loadedAnses);
    }
    catch(e)
    {
        ans = null ;
    }
    return ans ;
};

export function isExamAnswered(examId){
    return Boolean(localStorage.getItem('exam'+examId));
};

export function markThisExamAsSubmited(examId)
{
    localStorage.setItem('exam'+examId,true);
    saveCurrentQuestionIndex(examId,0);
    savePassedTime(examId,0);
    saveExamAnswers(examId,null);
}

export function savePassedTime(examId,timeInSecond)
{
    if(timeInSecond===0)
        localStorage.removeItem('exam_time'+examId);
    else
        localStorage.setItem('exam_time'+examId,20000-Math.round(timeInSecond));
}

export function getPassedTimeInSecond(examId)
{
    var time = localStorage.getItem('exam_time'+examId);
    if(time === null || time === undefined || isNaN(Number(time)))
    {
        if(getCurrentQuestionIndex(examId)>0 || loadExamAnswers(examId) != null)
            return 20000;
        return 0;
    }
    return 20000-Number(time);
}

export function saveCurrentQuestionIndex(examId,questionIndex)
{
    localStorage.setItem('exam_q'+examId,questionIndex);
}
export function getCurrentQuestionIndex(examId)
{
    var questionIndex = localStorage.getItem('exam_q'+examId);
    if(questionIndex === undefined || isNaN(Number(questionIndex)))
    {
        return 0;
    }
    return Number(questionIndex);
}